namespace('compass.group');

compass.group.GDSNamesWidget = compass.defineWidget(function GDSNamesWidget (options) {
	var me = this;
	var $j = jQuery;
	var d = jQuery.dom.getContext(this);

	var _settings = options;
	var _validator = options.validator;

	var _names = [];

	me.grabValues = function () {
		return _.map(_names, function (set) {
			var data = {};
			_.each(set, function (input) {
				data[input.attr("name")] = input.val();
			});

			return data;
		});
	};

	me.render = function (widgetElem) {
		_.each(_.range(_settings.number), function (n) {
			widgetElem.append(_createRoom(n));
		});
	};

	var _createRoom = function (index) {
		var fname = d.input({
			name: "firstName",
			type: "text",
			placeholder: "First Name",
			autocomplete: 'off'
		}).data("hint", "First name is required for this room.");
		var lname = d.input({
			name: "lastName",
			type: "text",
			placeholder: "Last Name",
			autocomplete: 'off'
		}).data("hint", "Last name is required for this room.");

		_names.push([ fname, lname ]);

		if (_validator) {
			_validator.addFields(fname, _validator.FILLED, { });
			_validator.addFields(lname, _validator.FILLED, { });
		}

		return d.div({ className: "GDS_Room" },
			d.label({ }, "Room " + (index+1)),
			fname,
			lname,
			d.div({ className: "clear" })
		);
	};
}, {
	WUID: 'DEFAULT',
	widgetName: 'GDSNamesWidget',
	number: 1
});
